import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { headingVariants, textVariants } from "../../variants/index.js";
const Heading_Heading = /*#__PURE__*/ forwardRef(function({ children, className, ...props }, ref) {
    const classes = cn(headingVariants(props), className);
    const Component = props.as || 'h1';
    const variantKeys = [
        ...Object.keys(textVariants.variants),
        'as'
    ];
    const domProps = cleanProps(props, variantKeys);
    return /*#__PURE__*/ jsx(Component, {
        ref: ref,
        className: classes,
        ...domProps,
        children: children
    });
});
export { Heading_Heading as Heading };
